import React  from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { YAxis } from "./Charts";

const Revenue = ({ settledPrices, filter }) => {

  const data = settledPrices
    .filter((item) => filter === "All" || item.block_name === filter)
    .sort((a, b) => new Date(a.booking_month) - new Date(b.booking_month));

  const sumColumnByKey = (data, groupKey, sumKey) => {
    const aggregatedData = data.reduce((acc, item) => {
      const key = item[groupKey];
      const value = item[sumKey];
      if (acc[key]) {
        acc[key] += value;
      } else {
        acc[key] = value;
      }
      return acc;
    }, {});
    return Object.values(aggregatedData);
  };

  const yAxis1 = sumColumnByKey(data, "booking_month", "expected_income");
  const yAxis2 = sumColumnByKey(data, "booking_month", "actual_earnings");
  const yAxis3 = sumColumnByKey(data, "booking_month", "not_paid");
  const yAxis4 = sumColumnByKey(data, "booking_month", "num_payments_expected");

  const xAxis = [...new Set(data.map((item) => 
    new Date(item.booking_month).toLocaleString("en-US", {
      month: "short",
      year: "numeric",
    })
  ))];

  return (
    <React.Fragment>
      <Card>
        <CardHeader className="border-0 align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Revenue over time</h4>
        </CardHeader>

        <CardBody className="p-0 pb-2">
          <div className="w-100">
            <div dir="ltr">
              <YAxis
                dataColors='["--vz-primary", "--vz-info", "--vz-success"]'
                x={xAxis}
                y1={yAxis1}
                y2={yAxis2}
                y3={yAxis3}
                y4={yAxis4}
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Revenue;
